module.exports = __webpack_public_path__ + "img/71.3.TP.648d8990.png";